<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="确认初检"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="5%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="检验项目" prop="InspectionItems">
        <el-input
          v-model="item.InspectionItems"
          placeholder="请输入检验项目"
        ></el-input>
      </el-form-item>
      <el-form-item label="维修人员" prop="MaintainUserID">
        <select2
          style="width: 100%"
          labelName="Name"
          v-model="item.MaintainUserID"
          url="user"
          :clearable="false"
          placeholder="请选择维修人员"
          no-data-text="没有用户"
        ></select2>
      </el-form-item>
      <el-form-item label="原因分析" prop="ReasonAnalyse">
        <el-input
          v-model="item.ReasonAnalyse"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入原因分析"
        ></el-input>
      </el-form-item>
      <el-form-item label="检验结论" prop="InspectionConclusion">
        <el-input
          v-model="item.InspectionConclusion"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入检验结论"
        ></el-input>
      </el-form-item>
      <el-form-item label="不合格等级" prop="Grade">
        <el-input
          v-model="item.Grade"
          placeholder="请输入不合格等级"
        ></el-input>
      </el-form-item>
      <el-form-item label="维修方案" prop="MaintainScheme">
        <el-input
          v-model="item.MaintainScheme"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入维修方案"
        ></el-input>
      </el-form-item>
      <el-form-item label="更换方式" prop="ReplacementMode">
        <el-radio-group v-model="item.ReplacementMode">
          <el-radio :label="0">不更换</el-radio>
          <el-radio :label="1">更换配件</el-radio>
          <el-radio :label="2" v-if="item.Type === 0">更换整机</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        InspectionItems: [
          { required: true, message: "检验项目不能为空", trigger: "blur" },
        ],
        MaintainUserID: [
          { required: true, message: "维修人员不能为空", trigger: "blur" },
        ],
        ReasonAnalyse: [
          { required: true, message: "原因分析不能为空", trigger: "blur" },
        ],
        InspectionConclusion: [
          { required: true, message: "检验结论不能为空", trigger: "blur" },
        ],
        Grade: [
          { required: true, message: "不合格等级不能为空", trigger: "blur" },
        ],
        MaintainScheme: [
          { required: true, message: "维修方案不能为空", trigger: "blur" },
        ],
        ReplacementMode: [
          { required: true, message: "更换方式不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      if (this.item.MaintainUserID === 0) {
        this.item.MaintainUserID = "";
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        const itemData = {
          ...this.item,
        };
        this.$axios
          .request({
            url: "dci/maintain/checkout",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("提交成功");
            this.submitting = false;
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
            this.$emit("cancel");
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
          });
      });
    },
  },
};
</script>
